import { AnchorType, IAddProjectCoverContent, Tag } from '@brg/api';
import React, { FC, useMemo, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  PresentationContainer,
  CheckboxRoot,
  PresentationWrapper,
  ContentLabel,
  CheckBoxInfoWrapper,
  HintLabel,
  HintLabelWrapper,
  HintIcon
} from './styles';
import { LayoutConst, } from 'core';
import { OrganizationsState } from 'shared/reducers/OrganizationsSlice';
import { MagicBox, FlexBox, FInter, HintTooltip } from '@brg/ui';
import { ReactComponent as CheckIcon } from "../../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../../assets/checkWhite.svg";
import { ProjectAuthorsChangeCbT } from '../../ProjectAuthorsEdit';
import { AuthorT } from '../../types';
import { ProjectEditPageGridInput } from '_deziiign/books/pages/BookEdit/styles';
import { CoverSettingsBlock } from './sections/CoverSettingsBlock';
import { ProjectSettingsBlock } from './sections/ProjectSettingsBlock';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import urlApi from 'shared/actions/urlApi';
import { useTranslation } from 'react-i18next';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';

export const INIT_ADDITIONAL_CONTENT: IAddProjectCoverContent = {
  title: {
    text: createDefaultLangObject(''),
    visible: false,
    color: '#000000'
  },
  subtitle: {
    text: createDefaultLangObject(''),
    visible: false,
    color: '#000000'
  },
  button: {
    text: createDefaultLangObject(''),
    color: '#000000',
    bgColor: '#000000',
    href: '',
    visible: false
  },
  anchors: {
    anchorVisible: undefined,
    anchorType: AnchorType.popup
  },
  annotation: {
    visible: false,
  }
}

export interface IPresentation {
    currentColor: string;
    requiredTags: Tag[];
    projectTags: Tag[];
    isModer?: boolean;
    tagEntityRequired?: string[];
    coAuthors?: AuthorT[];
    contextRequiredTags?: string[];
    tagEntity?: string[];
    errorsArray?: string[];
    errorProjectFill?: boolean;
    longReadLength?: number;
    organizationEntity?: OrganizationsState;
    vTYPE: string;
    title?: any;
    isBilingual: boolean;
    hasCover?: boolean;
    projectTitle?: string;
    toggleHideTitle?: (e: any) => void;
    toggleHideInfo?: (e: any) => void;
    titleIsHidden?: boolean;
    projectInfoIsHidden?: boolean;
    onAdditionalContentChange?: (data: any) => void;
    onTitlePositionChange?: (pos: string) => void;
    titlePosition?: string;
    onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
    onColorChange: (val: string) => void;
    onSetRequiredTags: (tagsRaw: Tag[]) => void;
    onSetProjectTags: (tagsRaw: Tag[]) => void;
    onMakeBilingual?: () => void;
    onDisableBilingual?: () => void;
    onToggleBilingual?: () => void;
    availability?: string;
    additionalContent?: IAddProjectCoverContent,
    setAvailability?: (availability: string) => void;
    handleLinkCopy?: (e: any) => void;
    toggleAgeRestricted?: (e: any) => void;
    isAgeRestricted?: boolean;
    project?: any;
    incomingType?: any;
    proTags: string[],
    isTeamProject?: boolean,
    moderationType?: ModerationType,
    /** Лендинг курса образовательной программы — настраивается как страница, а не как проект */
    isOuterCourse?: boolean,
    setProTags: (tagIds: string[]) => void;
}

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    disabled?: boolean;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    hintText?: string;
};

export const Footnote = styled(FInter.SmallTextDiv)`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const CopyLinkButton = styled(MagicBox)`
  cursor: pointer;
`

export const DropdownWrapper = styled(FlexBox)`
  ${ProjectEditPageGridInput} {
    width: 100% !important;

    .brg-input__control {
      background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;
      
      &:hover {
        cursor: pointer;
        border-color: transparent !important;
      }  
    }

    .brg-input__menu {
      div {
        background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;
        :hover {
          background-color: ${p => p.theme.projectEdit.presentation.input.dropdownHover} !important;
        }
      }
    }
    
    input {
      width: 100% !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1}px) {

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }
`;


export const PresentationBlockTest: FC<MagicBoxRowPropsT> = ({ onClick, checked, disabled, label, style, dark, hintText }) => {

  const baseStyle = { padding: '2px 8px 4px', justifyContent: 'flex-start' };
  const geoStyle ={ background: "#E7E7E7", color: "#70706F", justifyContent: 'flex-start' }

  const combinedStyle = { ...baseStyle, ...geoStyle };

    return (<MagicBox
        onClick={onClick}
        width="100%"
        pointer
        disabled={disabled}
        align="center"
        gx={16}
    >
        <CheckboxRoot checked={checked} isProjectPage>
            {checked && (
                <>
                    {dark ? <CheckIcon/> : <CheckWhite/>}
                </>
            )}
            <input checked={checked} type="checkbox"/>
        </CheckboxRoot>
        <CheckBoxInfoWrapper 
          width={hintText ? 'auto' : '100%'} 
          widthMobile={hintText ? 'auto' : '100%'} 
          gx={hintText ? 8 : 1}
          gxMobile={hintText ? 8 : 1}
          align={hintText ? 'center' : 'normal'}
        >
          <ContentLabel>
              {label}
          </ContentLabel>
          {hintText && (
            <HintTooltip positionY='top' customStyle={combinedStyle} noDisappearDelay onWhiteBg z={1} text={hintText}>
              <HintIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.375" y="0.375" width="11.25" height="11.25" rx="5.625" stroke="#909090" strokeWidth="0.75"/>
                <path d="M5.34345 8.00568V7.96413C5.34807 7.52326 5.39423 7.17241 5.48194 6.91158C5.56966 6.65075 5.6943 6.43954 5.85588 6.27797C6.01746 6.11639 6.21135 5.96751 6.43756 5.83132C6.57374 5.74822 6.69608 5.65012 6.80457 5.53702C6.91305 5.42161 6.99846 5.28888 7.06078 5.13885C7.12541 4.98881 7.15773 4.82262 7.15773 4.64027C7.15773 4.41406 7.10464 4.21786 6.99846 4.05167C6.89228 3.88548 6.75032 3.75737 6.57259 3.66735C6.39485 3.57733 6.1975 3.53231 5.98052 3.53231C5.79125 3.53231 5.6089 3.57156 5.43347 3.65004C5.25805 3.72852 5.11147 3.85201 4.99375 4.02051C4.87603 4.18901 4.80794 4.40945 4.78947 4.68182H3.91696C3.93542 4.28942 4.03699 3.95357 4.22165 3.67427C4.40861 3.39498 4.65444 3.18146 4.95913 3.03374C5.26612 2.88601 5.60659 2.81214 5.98052 2.81214C6.38677 2.81214 6.73993 2.89293 7.04001 3.05451C7.34239 3.21609 7.57552 3.43768 7.7394 3.71928C7.9056 4.00089 7.98869 4.32173 7.98869 4.68182C7.98869 4.93572 7.94945 5.16539 7.87097 5.37083C7.7948 5.57626 7.684 5.75977 7.53859 5.92134C7.39547 6.08292 7.22236 6.22603 7.01923 6.35067C6.81611 6.47763 6.65338 6.61151 6.53104 6.75231C6.4087 6.8908 6.31984 7.05584 6.26444 7.24743C6.20904 7.43901 6.17903 7.67791 6.17442 7.96413V8.00568H5.34345ZM5.78663 10.0554C5.61582 10.0554 5.46925 9.99423 5.34691 9.87189C5.22458 9.74956 5.16341 9.60298 5.16341 9.43217C5.16341 9.26136 5.22458 9.11479 5.34691 8.99245C5.46925 8.87012 5.61582 8.80895 5.78663 8.80895C5.95744 8.80895 6.10402 8.87012 6.22635 8.99245C6.34869 9.11479 6.40986 9.26136 6.40986 9.43217C6.40986 9.54528 6.381 9.64915 6.3233 9.74379C6.2679 9.83842 6.19288 9.9146 6.09824 9.9723C6.00591 10.0277 5.90204 10.0554 5.78663 10.0554Z" fill="#909090"/>
              </HintIcon>
            </HintTooltip>
          )}
        </CheckBoxInfoWrapper>
    </MagicBox>)
};

  export const Checkbox = styled(PresentationBlockTest)`
  width: 100%;
`

export const PresentationBlock: FC<IPresentation> = ({ 
  currentColor,                                     
  onColorChange,                                                   
  requiredTags,                                                   
  projectTags,
  coAuthors,                                                    
  onSetRequiredTags,
  onSetProjectTags, 
  onCoauthorChange,                                                  
  isModer = false,                                             
  tagEntityRequired,                                                     
  contextRequiredTags,                                    
  organizationEntity,                                                
  errorsArray,                                                 
  errorProjectFill,                                                 
  longReadLength,
  tagEntity,                                              
  vTYPE,                                                 
  moderationType,                                               
  isBilingual,                                                 
  onToggleBilingual,                                                  
  availability,                                                  
  setAvailability,                                                   
  handleLinkCopy,                                                   
  toggleHideTitle,                                                  
  toggleHideInfo,                                                     
  titleIsHidden,                                                    
  projectInfoIsHidden,
  toggleAgeRestricted,
  isAgeRestricted,
  hasCover,
  project,
  incomingType,
  proTags,
  setProTags,
  onTitlePositionChange,
  titlePosition,
  isTeamProject,
  isOuterCourse
  }) => {

    const { t, i18n } = useTranslation();
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
      const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
  useEffect(() => {
    urlApi()
      .getLendPresTagsTree(i18n.language)
      .then((tree: any[]) => {
        const root = tree?.[0] || { additionalTags: [] };
  
        const options = (root.additionalTags || []).map((tag: any) => {
          const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
          return {
            label: nameObj?.name || tag.title,
            value: tag.tagId,
          };
        });
  
        setProTypeOptions(options);
  
        setNavProTypeValue(prev => {
          if (!prev) return null;
          return options.find((opt: any) => opt.value === prev.value) || null;
        });
      })
      .catch(err => {
        console.error('Не удалось загрузить типы проектов', err);
      });
  }, [i18n.language]);

    useEffect(() => {
      if (incomingType) {
        setProTags([incomingType]);
      }
    }, [incomingType, setProTags]);

    const proTypeValue = useMemo(() => {
      if (proTags) {
        return proTypeOptions.find(({ value }) => value === proTags[0])
      }
    },[proTypeOptions, proTags])

    const setPresentationTag = useCallback((tag: any) => {
        setProTags([tag])
    }, [])

    // @ts-ignore
    const hasEducationalTagInNormalTags = useMemo(() => projectTags?.some(tag => tag?.isEducationTag), [projectTags]);

    const handleToggleBilingualClick = () => onToggleBilingual && onToggleBilingual()

    return (
      <>
        <PresentationWrapper hasCover={hasCover}>
          <HintLabelWrapper>
            <HintLabel>— {t('project_edit.hint_add_cover')}</HintLabel>
            <HintLabel>— {t('project_edit.hint_configure_presentation')}</HintLabel>
            <HintLabel>— {t('project_edit.hint_add_content_block')}</HintLabel>
          </HintLabelWrapper>
          <PresentationContainer vtype={vTYPE}>
            <CoverSettingsBlock
              vTYPE={vTYPE}
                  // @ts-ignore
              errorsArray={errorsArray}
              coAuthors={coAuthors}
              isBilingual={isBilingual}
              titleIsHidden={titleIsHidden}
              projectInfoIsHidden={projectInfoIsHidden}
              errorProjectFill={errorProjectFill}
              longReadLength={longReadLength}
              onCoauthorChange={onCoauthorChange}
              onTitlePositionChange={onTitlePositionChange}
              titlePosition={titlePosition}
              toggleHideInfo={toggleHideInfo}
              toggleHideTitle={toggleHideTitle}
            />
            <ProjectSettingsBlock
              project={project}
              vTYPE={vTYPE}
              currentColor={currentColor}
              isBilingual={isBilingual}
              proTypeValue={proTypeValue}
              proTypes={proTypeOptions}
              onSetPresentationTag={setPresentationTag}
              coAuthors={coAuthors}
              requiredTags={requiredTags}
              projectTags={projectTags}
              tagEntity={tagEntity}
              availability={availability}
              isAgeRestricted={isAgeRestricted}
              contextRequiredTags={contextRequiredTags}
              hasEducationTag={hasEducationalTagInNormalTags}
              tagEntityRequired={tagEntityRequired}
              onCoauthorChange={onCoauthorChange}
              toggleAgeRestricted={toggleAgeRestricted}
              onBilingualChange={handleToggleBilingualClick}
              onSetRequiredTag={(tag: any) => onSetRequiredTags(tag)}
              onSetProjectTags={(tag: any) => onSetProjectTags(tag)}
              onSetAvailability={setAvailability}
              onCopyLink={handleLinkCopy}
              onColorChange={onColorChange}
              isTeamProject={isTeamProject}
              moderationType={moderationType}
              isOuterCourse={isOuterCourse}
            />
          </PresentationContainer>
        </PresentationWrapper>
      </>
    )
}import { AnchorType, IAddProjectCoverContent, Tag } from '@brg/api';
import React, { FC, useMemo, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  PresentationContainer,
  CheckboxRoot,
  PresentationWrapper,
  ContentLabel,
  CheckBoxInfoWrapper,
  HintLabel,
  HintLabelWrapper,
  HintIcon
} from './styles';
import { LayoutConst, } from 'core';
import { OrganizationsState } from 'shared/reducers/OrganizationsSlice';
import { MagicBox, FlexBox, FInter, HintTooltip } from '@brg/ui';
import { ReactComponent as CheckIcon } from "../../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../../assets/checkWhite.svg";
import { ProjectAuthorsChangeCbT } from '../../ProjectAuthorsEdit';
import { AuthorT } from '../../types';
import { ProjectEditPageGridInput } from '_deziiign/books/pages/BookEdit/styles';
import { CoverSettingsBlock } from './sections/CoverSettingsBlock';
import { ProjectSettingsBlock } from './sections/ProjectSettingsBlock';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import urlApi from 'shared/actions/urlApi';
import { useTranslation } from 'react-i18next';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';

export const INIT_ADDITIONAL_CONTENT: IAddProjectCoverContent = {
  title: {
    text: createDefaultLangObject(''),
    visible: false,
    color: '#000000'
  },
  subtitle: {
    text: createDefaultLangObject(''),
    visible: false,
    color: '#000000'
  },
  button: {
    text: createDefaultLangObject(''),
    color: '#000000',
    bgColor: '#000000',
    href: '',
    visible: false
  },
  anchors: {
    anchorVisible: undefined,
    anchorType: AnchorType.popup
  },
  annotation: {
    visible: false,
  }
}

export interface IPresentation {
    currentColor: string;
    requiredTags: Tag[];
    projectTags: Tag[];
    isModer?: boolean;
    tagEntityRequired?: string[];
    coAuthors?: AuthorT[];
    contextRequiredTags?: string[];
    tagEntity?: string[];
    errorsArray?: string[];
    errorProjectFill?: boolean;
    longReadLength?: number;
    organizationEntity?: OrganizationsState;
    vTYPE: string;
    title?: any;
    isBilingual: boolean;
    hasCover?: boolean;
    projectTitle?: string;
    toggleHideTitle?: (e: any) => void;
    toggleHideInfo?: (e: any) => void;
    titleIsHidden?: boolean;
    projectInfoIsHidden?: boolean;
    onAdditionalContentChange?: (data: any) => void;
    onTitlePositionChange?: (pos: string) => void;
    titlePosition?: string;
    onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
    onColorChange: (val: string) => void;
    onSetRequiredTags: (tagsRaw: Tag[]) => void;
    onSetProjectTags: (tagsRaw: Tag[]) => void;
    onMakeBilingual?: () => void;
    onDisableBilingual?: () => void;
    onToggleBilingual?: () => void;
    availability?: string;
    additionalContent?: IAddProjectCoverContent,
    setAvailability?: (availability: string) => void;
    handleLinkCopy?: (e: any) => void;
    toggleAgeRestricted?: (e: any) => void;
    isAgeRestricted?: boolean;
    project?: any;
    incomingType?: any;
    proTags: string[],
    isTeamProject?: boolean,
    moderationType?: ModerationType,
    /** Лендинг курса образовательной программы — настраивается как страница, а не как проект */
    isOuterCourse?: boolean,
    setProTags: (tagIds: string[]) => void;
}

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    disabled?: boolean;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    hintText?: string;
};

export const Footnote = styled(FInter.SmallTextDiv)`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const CopyLinkButton = styled(MagicBox)`
  cursor: pointer;
`

export const DropdownWrapper = styled(FlexBox)`
  ${ProjectEditPageGridInput} {
    width: 100% !important;

    .brg-input__control {
      background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;
      
      &:hover {
        cursor: pointer;
        border-color: transparent !important;
      }  
    }

    .brg-input__menu {
      div {
        background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;
        :hover {
          background-color: ${p => p.theme.projectEdit.presentation.input.dropdownHover} !important;
        }
      }
    }
    
    input {
      width: 100% !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1}px) {

    .brg-input__control {
      height: 36px !important;
    }

    .brg-input__menu {
      margin-top: 5px;
    }

    .brg-input__indicator {
      padding-top: 5px;
    }
  }
`;


export const PresentationBlockTest: FC<MagicBoxRowPropsT> = ({ onClick, checked, disabled, label, style, dark, hintText }) => {

  const baseStyle = { padding: '2px 8px 4px', justifyContent: 'flex-start' };
  const geoStyle ={ background: "#E7E7E7", color: "#70706F", justifyContent: 'flex-start' }

  const combinedStyle = { ...baseStyle, ...geoStyle };

    return (<MagicBox
        onClick={onClick}
        width="100%"
        pointer
        disabled={disabled}
        align="center"
        gx={16}
    >
        <CheckboxRoot checked={checked} isProjectPage>
            {checked && (
                <>
                    {dark ? <CheckIcon/> : <CheckWhite/>}
                </>
            )}
            <input checked={checked} type="checkbox"/>
        </CheckboxRoot>
        <CheckBoxInfoWrapper 
          width={hintText ? 'auto' : '100%'} 
          widthMobile={hintText ? 'auto' : '100%'} 
          gx={hintText ? 8 : 1}
          gxMobile={hintText ? 8 : 1}
          align={hintText ? 'center' : 'normal'}
        >
          <ContentLabel>
              {label}
          </ContentLabel>
          {hintText && (
            <HintTooltip positionY='top' customStyle={combinedStyle} noDisappearDelay onWhiteBg z={1} text={hintText}>
              <HintIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.375" y="0.375" width="11.25" height="11.25" rx="5.625" stroke="#909090" strokeWidth="0.75"/>
                <path d="M5.34345 8.00568V7.96413C5.34807 7.52326 5.39423 7.17241 5.48194 6.91158C5.56966 6.65075 5.6943 6.43954 5.85588 6.27797C6.01746 6.11639 6.21135 5.96751 6.43756 5.83132C6.57374 5.74822 6.69608 5.65012 6.80457 5.53702C6.91305 5.42161 6.99846 5.28888 7.06078 5.13885C7.12541 4.98881 7.15773 4.82262 7.15773 4.64027C7.15773 4.41406 7.10464 4.21786 6.99846 4.05167C6.89228 3.88548 6.75032 3.75737 6.57259 3.66735C6.39485 3.57733 6.1975 3.53231 5.98052 3.53231C5.79125 3.53231 5.6089 3.57156 5.43347 3.65004C5.25805 3.72852 5.11147 3.85201 4.99375 4.02051C4.87603 4.18901 4.80794 4.40945 4.78947 4.68182H3.91696C3.93542 4.28942 4.03699 3.95357 4.22165 3.67427C4.40861 3.39498 4.65444 3.18146 4.95913 3.03374C5.26612 2.88601 5.60659 2.81214 5.98052 2.81214C6.38677 2.81214 6.73993 2.89293 7.04001 3.05451C7.34239 3.21609 7.57552 3.43768 7.7394 3.71928C7.9056 4.00089 7.98869 4.32173 7.98869 4.68182C7.98869 4.93572 7.94945 5.16539 7.87097 5.37083C7.7948 5.57626 7.684 5.75977 7.53859 5.92134C7.39547 6.08292 7.22236 6.22603 7.01923 6.35067C6.81611 6.47763 6.65338 6.61151 6.53104 6.75231C6.4087 6.8908 6.31984 7.05584 6.26444 7.24743C6.20904 7.43901 6.17903 7.67791 6.17442 7.96413V8.00568H5.34345ZM5.78663 10.0554C5.61582 10.0554 5.46925 9.99423 5.34691 9.87189C5.22458 9.74956 5.16341 9.60298 5.16341 9.43217C5.16341 9.26136 5.22458 9.11479 5.34691 8.99245C5.46925 8.87012 5.61582 8.80895 5.78663 8.80895C5.95744 8.80895 6.10402 8.87012 6.22635 8.99245C6.34869 9.11479 6.40986 9.26136 6.40986 9.43217C6.40986 9.54528 6.381 9.64915 6.3233 9.74379C6.2679 9.83842 6.19288 9.9146 6.09824 9.9723C6.00591 10.0277 5.90204 10.0554 5.78663 10.0554Z" fill="#909090"/>
              </HintIcon>
            </HintTooltip>
          )}
        </CheckBoxInfoWrapper>
    </MagicBox>)
};

  export const Checkbox = styled(PresentationBlockTest)`
  width: 100%;
`

export const PresentationBlock: FC<IPresentation> = ({ 
  currentColor,                                     
  onColorChange,                                                   
  requiredTags,                                                   
  projectTags,
  coAuthors,                                                    
  onSetRequiredTags,
  onSetProjectTags, 
  onCoauthorChange,                                                  
  isModer = false,                                             
  tagEntityRequired,                                                     
  contextRequiredTags,                                    
  organizationEntity,                                                
  errorsArray,                                                 
  errorProjectFill,                                                 
  longReadLength,
  tagEntity,                                              
  vTYPE,                                                 
  moderationType,                                               
  isBilingual,                                                 
  onToggleBilingual,                                                  
  availability,                                                  
  setAvailability,                                                   
  handleLinkCopy,                                                   
  toggleHideTitle,                                                  
  toggleHideInfo,                                                     
  titleIsHidden,                                                    
  projectInfoIsHidden,
  toggleAgeRestricted,
  isAgeRestricted,
  hasCover,
  project,
  incomingType,
  proTags,
  setProTags,
  onTitlePositionChange,
  titlePosition,
  isTeamProject,
  isOuterCourse
  }) => {

    const { t, i18n } = useTranslation();
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
      const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
  useEffect(() => {
    urlApi()
      .getLendPresTagsTree(i18n.language)
      .then((tree: any[]) => {
        const root = tree?.[0] || { additionalTags: [] };
  
        const options = (root.additionalTags || []).map((tag: any) => {
          const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
          return {
            label: nameObj?.name || tag.title,
            value: tag.tagId,
          };
        });
  
        setProTypeOptions(options);
  
        setNavProTypeValue(prev => {
          if (!prev) return null;
          return options.find((opt: any) => opt.value === prev.value) || null;
        });
      })
      .catch(err => {
        console.error('Не удалось загрузить типы проектов', err);
      });
  }, [i18n.language]);

    useEffect(() => {
      if (incomingType) {
        setProTags([incomingType]);
      }
    }, [incomingType, setProTags]);

    const proTypeValue = useMemo(() => {
      if (proTags) {
        return proTypeOptions.find(({ value }) => value === proTags[0])
      }
    },[proTypeOptions, proTags])

    const setPresentationTag = useCallback((tag: any) => {
        setProTags([tag])
    }, [])

    // @ts-ignore
    const hasEducationalTagInNormalTags = useMemo(() => projectTags?.some(tag => tag?.isEducationTag), [projectTags]);

    const handleToggleBilingualClick = () => onToggleBilingual && onToggleBilingual()

    return (
      <>
        <PresentationWrapper hasCover={hasCover}>
          <HintLabelWrapper>
            <HintLabel>— {t('project_edit.hint_add_cover')}</HintLabel>
            <HintLabel>— {t('project_edit.hint_configure_presentation')}</HintLabel>
            <HintLabel>— {t('project_edit.hint_add_content_block')}</HintLabel>
          </HintLabelWrapper>
          <PresentationContainer vtype={vTYPE}>
            <CoverSettingsBlock
              vTYPE={vTYPE}
                  // @ts-ignore
              errorsArray={errorsArray}
              coAuthors={coAuthors}
              isBilingual={isBilingual}
              titleIsHidden={titleIsHidden}
              projectInfoIsHidden={projectInfoIsHidden}
              errorProjectFill={errorProjectFill}
              longReadLength={longReadLength}
              onCoauthorChange={onCoauthorChange}
              onTitlePositionChange={onTitlePositionChange}
              titlePosition={titlePosition}
              toggleHideInfo={toggleHideInfo}
              toggleHideTitle={toggleHideTitle}
            />
            <ProjectSettingsBlock
              project={project}
              vTYPE={vTYPE}
              currentColor={currentColor}
              isBilingual={isBilingual}
              proTypeValue={proTypeValue}
              proTypes={proTypeOptions}
              onSetPresentationTag={setPresentationTag}
              coAuthors={coAuthors}
              requiredTags={requiredTags}
              projectTags={projectTags}
              tagEntity={tagEntity}
              availability={availability}
              isAgeRestricted={isAgeRestricted}
              contextRequiredTags={contextRequiredTags}
              hasEducationTag={hasEducationalTagInNormalTags}
              tagEntityRequired={tagEntityRequired}
              onCoauthorChange={onCoauthorChange}
              toggleAgeRestricted={toggleAgeRestricted}
              onBilingualChange={handleToggleBilingualClick}
              onSetRequiredTag={(tag: any) => onSetRequiredTags(tag)}
              onSetProjectTags={(tag: any) => onSetProjectTags(tag)}
              onSetAvailability={setAvailability}
              onCopyLink={handleLinkCopy}
              onColorChange={onColorChange}
              isTeamProject={isTeamProject}
              moderationType={moderationType}
              isOuterCourse={isOuterCourse}
            />
          </PresentationContainer>
        </PresentationWrapper>
      </>
    )
}